import React from 'react';
import { useGetQuestionQuery, usePostCommentMutation } from '../../apis';
import { QuestionCard } from '../../components/QuestionCard/QuestionCard';
import { CommentCard } from '../../components/CommentCard/CommentCard';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Spinner, SpinnerVariants } from '../../UI';
import { getToken } from '../../utils/auth';
import { CommentForm } from '../../components';

export const Question: React.FC = () => {

  const { questionId } = useParams<{ questionId: string }>();
  const token = getToken();
  const navigate = useNavigate();
  const location = useLocation();

  const [postComment] = usePostCommentMutation();
  const { data, isLoading, isError } = useGetQuestionQuery({ questionId: questionId! });

  const requireAuth = () => navigate('/login', { state: { backgroundLocation: location } });

  const handleComment = (content: string) => {
    postComment({ questionId: questionId!, content });

  };

  if (isLoading) {
    return <div className='flex justify-center'>
      <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
    </div>;
  }

  if (isError || !data) {
    return <div className='flex justify-center p-app-lg text-app-gray'>
      Could not load this question. Please try again.
    </div>;
  }

  return (
    <div className='no-scrollbar overflow-y-scroll bg-app-card flex flex-1 flex-col rounded-app-base'>
      <QuestionCard data={data} key={data.questionId} />
      <div className='px-app-lg pb-app-lg'>
        {
          token
            ? <CommentForm onSubmit={handleComment} />
            : <button
              type="button"
              onClick={requireAuth}
              className='text-app-base text-app-secondary hover:underline py-app-sm'
            >
              Log in to comment
            </button>
        }
        {
          data.comments?.map(comment => {
            return <CommentCard data={comment} key={comment._id} />;
          })
        }
      </div>
    </div>
  );
};
